import React, { useEffect, useState } from 'react';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';
import { Banner } from '@/components/Banner/Banner';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import Typography from '@latitude/typography';
import { getCdrEntryBindingRichTextOptions } from '@/utils/contentfulRichTextBindings';

const OPTIONS = getCdrEntryBindingRichTextOptions({
  renderNode: {
    [INLINES.HYPERLINK]: (node, children) => (
      <Typography.LinkRegular
        color={REBRAND_COLOR.INDIGO}
        href={node.data.uri}
        trackEventData={{ location: 'banner' }}
      >
        {children}
      </Typography.LinkRegular>
    ),
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <Typography.Body>{children}</Typography.Body>
    )
  }
});

const checkDateExpired = date => {
  if (!date) return false;
  const expiredDate = new Date(date);
  const now = Date.now();
  return now > expiredDate;
};

const Alert = ({ message, siteName, visible, showCloseIcon, expireDate }) => {
  const [isVisible, setIsVisible] = useState(visible);
  const [isClose, setIsClose] = useState(showCloseIcon);

  useEffect(() => {
    if (
      sessionStorage.getItem(siteName + '_closeStatus') === 'true' ||
      checkDateExpired(expireDate)
    ) {
      setIsClose(false);
      setIsVisible(false);
    }
  }, []);

  const handleClose = () => {
    if (isClose) {
      setIsClose(false);
      setIsVisible(false);
      sessionStorage.setItem(siteName + '_closeStatus', true);
    }
  };

  return isVisible ? (
    <Banner onClose={isClose && handleClose} showClose={isClose}>
      {documentToReactComponents(message, OPTIONS)}
    </Banner>
  ) : (
    <></>
  );
};

export default Alert;
